import { del, EndPoints, get, patch, post } from '../';
export function list() {
    return get(EndPoints.wounds, { all: 1 });
}
export function createWound(request) {
    return post(EndPoints.woundsCreate, request);
}
export function updateWound(request) {
    return patch(EndPoints.woundsUpdate, request);
}
export function deleteWound(request) {
    return del("" + EndPoints.woundsDelete, request);
}
